import { render } from "./Home.vue?vue&type=template&id=0744fd32&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=0744fd32&scoped=true&lang=css"

import exportComponent from "/Users/siorikitajima/Dropbox (Personal)/Code/GCV/ga-emc/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0744fd32"]])

export default __exports__